"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "document-mid"), /*#__PURE__*/React.createElement("g", {
    id: "980dcd6d-de68-4dbe-b26d-80807e76e887",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d33e5a63-9a82-4dab-a18a-cdc361845449",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("line", {
    id: "9afcf3a1-87f3-4d90-95cb-4da0dc63add8",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 134,
    x2: 66,
    y2: 134,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "d28122dc-f11f-4e9f-89ed-1cada6109402",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 86,
    x2: 66,
    y2: 86,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "9bac14af-34a8-4132-84fa-31c8f6ca9163",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 110,
    x2: 66,
    y2: 110,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,18H56c-6.63,0-14,7.37-14,14V160a14,14,0,0,0,14,14h80a14,14,0,0,0,14-14V54Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,18V50a4,4,0,0,0,4,4h32",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}

var _default = ic_document;
exports.default = _default;